import { LabelNames } from "../shared/core/ovs.core";

export class ResortListingLabelNames {
    public static NoSearchResults = 'no_search_results';
    public static Welcome = LabelNames.Welcome;
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/resort-listing/resort-listing-label-names.ts